// Lazy load apps

document.addEventListener('scroll', () => {
  // Gorgias lazy load
  loadOnScroll('https://config.gorgias.chat/gorgias-chat-bundle-loader.js?applicationId=10976', 'gorgias-chat-widget-install-v2');
  loadOnScroll('https://static.rechargecdn.com/assets/js/widget.min.js?shop=betterrhodes.myshopify.com', 'recharge-loader');
});

const loadOnScroll = (src, id) => {
  const body = document.querySelector('body');
  if (!document.querySelector('#' + id)) {
    const script = document.createElement('script');
    script.src = src;
    script.setAttribute('id', id);
    body.append(script);
  }
};